import {
    ConditionType_BooleanEquals,
} from "../../model2/conditions/condition-types"
import Filter from "../../manager/filters/manager/filter"

export const FIELD_CONDITIONS_BOOLEAN     = [
    ConditionType_BooleanEquals
]

// const debug = "FieldBoolean_filterFunc"
const debug = false

export function FieldBoolean_filterFunc(filter: Filter, model:any): boolean {
    if (!filter.type || _.isNil(filter.value)) return true

    const fieldValue = _.get(model, filter.field?.fieldId!, false)

    debug && console.log(debug, 'process', fieldValue, filter.value, fieldValue === filter.value)

    return fieldValue === filter.value
}